import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Youtube } from 'lucide-react';

const SOCIALS = [
  { name: 'Facebook', href: 'https://www.facebook.com/profile.php?id=61590532937785', Icon: Facebook },
  { name: 'Instagram', href: 'https://www.instagram.com/novareelos/', Icon: Instagram },
  { name: 'YouTube', href: 'https://www.youtube.com/@InfoNovaReel', Icon: Youtube },
];

const TikTokIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5.8 20.1a6.34 6.34 0 0 0 10.86-4.43V8.55a8.16 8.16 0 0 0 4.77 1.52V6.69z"/>
  </svg>
);

const SUPPORT_EMAIL = 'Support@Novareelhub.com';
const SUPPORT_MAILTO = `mailto:${SUPPORT_EMAIL}`;
const HELP_MAILTO = `mailto:${SUPPORT_EMAIL}?subject=NovaReelTV%20Help%20Request`;

const LINK_GROUPS = [
  [
    { label: 'Help Center', href: HELP_MAILTO, external: true },
    { label: 'Contact Us', href: SUPPORT_MAILTO, external: true },
    { label: 'Media Center', href: SUPPORT_MAILTO, external: true },
  ],
  [
    { label: 'Terms of Use', to: '/terms' },
    { label: 'Privacy', to: '/privacy' },
    { label: 'Cookie Preferences', to: '/privacy#cookies' },
  ],
  [
    { label: 'Investor Relations', href: SUPPORT_MAILTO, external: true },
    { label: 'Jobs', href: SUPPORT_MAILTO, external: true },
    { label: 'Advertise With Us', href: `mailto:${SUPPORT_EMAIL}?subject=Advertise%20With%20Us%20on%20NovaReelTV`, external: true },
  ],
  [
    { label: 'Audio Description', href: SUPPORT_MAILTO, external: true },
    { label: 'Legal Notices', to: '/terms#legal' },
    { label: 'Corporate Information', to: '/terms#corporate' },
  ],
];

const Footer = () => (
  <footer className="mt-16 px-4 md:px-14 py-10 text-white/60 text-sm max-w-6xl mx-auto">
    <div className="flex items-center gap-4 mb-6">
      {SOCIALS.map(({ name, href, Icon }) => (
        <a
          key={name}
          href={href}
          target="_blank"
          rel="noreferrer"
          aria-label={name}
          className="text-white/70 hover:text-white transition-colors"
        >
          <Icon className="w-5 h-5" />
        </a>
      ))}
      <a
        href="https://www.tiktok.com/@novareelos7"
        target="_blank"
        rel="noreferrer"
        aria-label="TikTok"
        className="text-white/70 hover:text-white transition-colors"
      >
        <TikTokIcon className="w-5 h-5" />
      </a>
    </div>

    <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-6">
      {LINK_GROUPS.flat().map((l) =>
        l.to ? (
          <Link key={l.label} to={l.to} className="hover:underline">{l.label}</Link>
        ) : (
          <a
            key={l.label}
            href={l.href}
            target={l.external ? '_blank' : undefined}
            rel={l.external ? 'noreferrer' : undefined}
            className="hover:underline"
          >
            {l.label}
          </a>
        )
      )}
    </div>

    <p className="text-xs">
      Questions? <a href={SUPPORT_MAILTO} className="underline hover:text-white">{SUPPORT_EMAIL}</a>
    </p>
    <p className="text-xs mt-1">© 2025 NovaReelTV, Inc. Free to watch. Supported by ads.</p>
  </footer>
);

export default Footer;
